import { render, staticRenderFns } from "./ccf-intro.vue?vue&type=template&id=27187f3b&"
import script from "./ccf-intro.vue?vue&type=script&lang=js&"
export * from "./ccf-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports